module.exports = __webpack_public_path__ + "static/media/px-company.31e910dc.svg";